import { 
  IDENTIFING_USER_SUCCEEDED, 
  SUBMIT_CONTACT_FORM_REQUEST, SUBMITTING_CONTACT_FORM_SUCCEEDED, SUBMITTING_CONTACT_FORM_FAILED
} from '../constants/actionTypes.jsx';

const initialState = {
  form: {
    submiting: false,
    submited: false,
    token: null
  },
  contact: null 
}

function appReducer(state = initialState, action) {
  switch (action.type) {
    case SUBMIT_CONTACT_FORM_REQUEST:
      return {
        ...state,
        form: {
          ...state.form,
          submiting: true,
          submited: false
        }
      }
    case SUBMITTING_CONTACT_FORM_SUCCEEDED:
      return {
        ...state,
        form: {
          ...state.form,
          submiting: false,
          submited: true,
          token: action.payload.response.token
        },
        contact: action.payload.response.contact
      }
    case SUBMITTING_CONTACT_FORM_FAILED:
      return {
        ...state,
        form: {
          ...state.form,
          submiting: false,
          submited: false,
          error: action.payload.error
        }
      }
    case IDENTIFING_USER_SUCCEEDED:
      return {
        ...state,
        contact: action.payload
      }

    default:
      return state
  }
}

export { appReducer };